(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-swc-related-carousel]';

  const revealControls = (root, sliderElement) => {
    const controls = root.querySelector('.m-slider-controls');
    const previousButton = root.querySelector('.m-slider-controls__button-prev');
    const nextButton = root.querySelector('.m-slider-controls__button-next');

    controls?.classList.remove('m:hidden');

    [previousButton, nextButton].forEach((button) => {
      if (!button) return;
      button.classList.remove('m:hidden');
      button.type = 'button';
      button.setAttribute('aria-controls', sliderElement.id);
    });
  };

  const initializeCarousel = (root) => {
    if (!root || root.dataset.swcCarouselReady === 'true') return;
    if (root.dataset.enableSlider !== 'true') return;

    const sliderElement = root.querySelector('.swiper-container');
    const slides = root.querySelectorAll('.swiper-slide');

    if (!sliderElement || slides.length < 2) return;

    if (!window.MinimogLibs || typeof window.MinimogLibs.Swiper !== 'function') {
      const attempts = Number(root.dataset.swcCarouselAttempts || 0);
      if (attempts >= 100) return;
      root.dataset.swcCarouselAttempts = String(attempts + 1);
      window.setTimeout(() => initializeCarousel(root), 50);
      return;
    }

    root.dataset.swcCarouselReady = 'true';
    root.querySelector('.m-mixed-layout')?.classList.remove('m-mixed-layout--mobile-scroll');

    const previousButton = root.querySelector('.m-slider-controls__button-prev');
    const nextButton = root.querySelector('.m-slider-controls__button-next');
    const itemsPerPage = Math.max(2, Number(root.dataset.itemsPerPage || 4));
    const tabletItems = Math.max(2, itemsPerPage - 1);

    root.swcRelatedSlider = new window.MinimogLibs.Swiper(sliderElement, {
      slidesPerView: 2,
      loop: false,
      autoplay: false,
      threshold: 2,
      allowTouchMove: true,
      watchOverflow: true,
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton
      },
      breakpoints: {
        768: {
          slidesPerView: tabletItems
        },
        1280: {
          slidesPerView: itemsPerPage
        }
      },
      on: {
        init: () => revealControls(root, sliderElement)
      }
    });

    revealControls(root, sliderElement);
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.(selector)) initializeCarousel(scope);
    scope.querySelectorAll?.(selector).forEach(initializeCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(selector)
      ? event.target
      : event.target.querySelector?.(selector);

    root?.swcRelatedSlider?.destroy(true, true);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
